/**
 * Section wrappers for Settings sub-routes.
 *
 * Each existing tab content component (TeamTab, ApiKeysTab, WebhooksTab, and
 * the four Telegram tabs) gets a thin wrapper that adds a section header so
 * the embedded route has a title, since the new Settings layout doesn't
 * provide one globally.
 */
import React from "react";
import PageHeader from "components/PageLayout";
import ApiKeysTab from "./ApiKeysTab";
import WebhooksTab from "./WebhooksTab";
import TeamTab from "./TeamTab";
import SubscribersTab from "../telegram/SubscribersTab";

export function ApiKeysSection() {
  return (
    <div>
      <PageHeader
        title="API Keys"
        subtitle="Manage API credentials for partner integrations."
      />
      <div className="container py-6">
        <ApiKeysTab />
      </div>
    </div>
  );
}

export function WebhooksSection() {
  return (
    <div>
      <PageHeader
        title="Webhooks"
        subtitle="Subscriptions and delivery history for outbound webhooks."
      />
      <div className="container py-6">
        <WebhooksTab />
      </div>
    </div>
  );
}

export function TeamSection() {
  return (
    <div>
      <PageHeader
        title="Team"
        subtitle="Members, invitations, and role management."
      />
      <div className="container py-6">
        <TeamTab />
      </div>
    </div>
  );
}

// TelegramNotificationsSection retired (SOUND-247) — it held a free-text
// broadcast to ALL subscribers with no confirmation. Rebuild deliberately, with
// an approval step, if CRM -> Telegram messaging is ever needed.
// TelegramTemplatesSection retired (SOUND-523) — template authoring moved to the
// notifications admin surface (/settings/notification-config).

export function TelegramSubscribersSection() {
  return (
    <div>
      <PageHeader
        title="Telegram · Subscribers"
        subtitle="Bot subscribers across companies."
      />
      <div className="container py-6">
        <SubscribersTab />
      </div>
    </div>
  );
}

